import { Component, Inject, OnInit } from '@angular/core';
import { PerfilUsuario } from 'src/app/common/interfaces/perfil-usuario.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToolsService } from '@services/varios/tools.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-perfiles-usuario',
  templateUrl: './perfiles-usuario.component.html',
  styleUrls: ['./perfiles-usuario.component.scss']
})
export class PerfilesUsuarioComponent implements OnInit {

  public perfiles: PerfilUsuario[] = this.data.perfiles;
  public perfilesSeleccionados : PerfilUsuario[] = this.data.perfilesSeleccionados;
  public ordenJerarquia: number = 0;

  constructor( 
    public readonly toolsService: ToolsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<PerfilesUsuarioComponent>,
    private readonly authService: AuthService) { }
  
  async ngOnInit(): Promise<void> {
    let UsrInfo = this.authService.getUserInfo();
    this.ordenJerarquia = UsrInfo.usuario.perfiles.filter(x=>x.idPerfil == UsrInfo.usuario.idPerfil)[0].ordenJerarquia;
  }
 
  async closeDialogPerfilesUsuario()  {
    if (!this.validarSeleccion()) {
      await this.toolsService.errorMensaje('Debe seleccionar al menos un perfil.');
      return;
    }

    this.dialogRef.close( { data: {
      perfilesSeleccionados : this.perfiles
    } });
  }

  validarSeleccion(): boolean {
    return this.perfiles.some(perfil => perfil.checked);
  }
}